import React, { useEffect, useState } from 'react';
import { Stack, StackItem, Text, Image } from '@fluentui/react';
import { DirectionsRenderer, InfoWindow, Marker } from '@react-google-maps/api';
import moment from 'moment';

import ItemRegistroTiempo from '../../models/ItemRegistroTiempo';
import ItemTarea from '../../models/ItemTarea';

import playIcon from '../../assets/img24/play_24.png';
import flagIcon from '../../assets/img24/finalizado_24.png';
import pauseIcon from '../../assets/img24/pause_24.png';

const getLatLng = (value: string) : google.maps.LatLng => {
    const valueArray : string[] = value.split(',');
    return new google.maps.LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
};

const isSameDay = (date1: string, date2: string) : boolean => {
    return moment(date1).format("YYYYMMDD") === moment(date2).format("YYYYMMDD");
};

interface IGoogleMapMarkerOrderComponentProps {
    work: ItemTarea;
    workPart: ItemRegistroTiempo;
    selectedWorkPart?: ItemRegistroTiempo;
    selectedStart: boolean;
    onSelect: (workPart: ItemRegistroTiempo, start: boolean) => void;
};

const GoogleMapMarkerOrderComponent = (props: IGoogleMapMarkerOrderComponentProps) => {
    const [directions, setDirections] = useState<google.maps.DirectionsResult>();

    useEffect(() => {
        if (props.workPart.PosicionGPSInicio && props.workPart.PosicionGPSFinal) {
            const googleDataPositionInicio : google.maps.LatLng = getLatLng(props.workPart.PosicionGPSInicio);
            const googleDataPositionFin : google.maps.LatLng = getLatLng(props.workPart.PosicionGPSFinal);

            const directionsService : google.maps.DirectionsService = new google.maps.DirectionsService();
            directionsService.route({
                origin: googleDataPositionInicio,
                destination: googleDataPositionFin,
                travelMode: google.maps.TravelMode.DRIVING,
            }, (result: google.maps.DirectionsResult | null, status: google.maps.DirectionsStatus) => {
                if (result && status === google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                }
                else {
                    console.error(`error fetching directions ${result}`);
                }
            });
        }
        else {
            setDirections(undefined);
        }
    }, [props.workPart.PosicionGPSInicio, props.workPart.PosicionGPSFinal]);

    return (
        <>
            {
                props.workPart.PosicionGPSInicio ? (
                    <Marker 
                        position={getLatLng(props.workPart.PosicionGPSInicio)} 
                        onClick={() => {
                            props.onSelect(props.workPart, true);
                        }}>
                        {
                            (props.selectedStart && props.workPart.Id === props.selectedWorkPart?.Id) ? (
                                <InfoWindow position={getLatLng(props.workPart.PosicionGPSInicio)}>
                                    <>
                                        <Stack horizontal={true}>
                                            <StackItem>
                                                {
                                                    !props.workPart.Fin ? (
                                                        <Image 
                                                            src={playIcon}
                                                            alt="Finalizado"
                                                            height={24}
                                                            width={24} />
                                                    ) : props.work.FechaFinalizacion ? (
                                                        <Image 
                                                            src={flagIcon}
                                                            alt="Finalizado"
                                                            height={24}
                                                            width={24} />
                                                    ) : (
                                                        <Image 
                                                            src={pauseIcon}
                                                            alt="Finalizado"
                                                            height={24}
                                                            width={24} />
                                                    )
                                                }
                                            </StackItem>
                                            <StackItem styles={{
                                                root: {
                                                    paddingLeft: 10,
                                                },
                                            }}>
                                                <Text variant="xSmall">
                                                    {
                                                        !props.workPart.Fin ? (
                                                            `${moment(props.workPart.Inicio).format("DD-MM-YYYY HH:mm")}h - --:--`
                                                        ) : isSameDay(props.workPart.Inicio, props.workPart.Fin) ? (
                                                            `${moment(props.workPart.Inicio).format("DD-MM-YYYY HH:mm")}h - ${moment(props.workPart.Fin).format("HH:mm")}h`
                                                        ) : (
                                                            `${moment(props.workPart.Inicio).format("DD-MM-YYYY HH:mm")}h - ${moment(props.workPart.Fin).format("DD-MM-YYYY HH:mm")}h`
                                                        )
                                                    }
                                                </Text>
                                            </StackItem>
                                        </Stack>
                                        <Text>
                                            {props.workPart.Descripcion}
                                        </Text>
                                    </>
                                </InfoWindow>
                            ) : (
                                null
                            )
                        }
                    </Marker>
                ) : (
                    null
                )
            }
            {
                props.workPart.PosicionGPSFinal ? (
                    <Marker 
                        position={getLatLng(props.workPart.PosicionGPSFinal)} 
                        onClick={() => {
                            props.onSelect(props.workPart, false);
                        }}>
                        {
                            (!props.selectedStart && props.workPart.Id === props.selectedWorkPart?.Id) ? (
                                <InfoWindow position={getLatLng(props.workPart.PosicionGPSFinal)}>
                                    <>
                                        <Stack horizontal={true}>
                                            <StackItem>
                                                {
                                                    !props.workPart.Fin ? (
                                                        <Image 
                                                            src={playIcon}
                                                            alt="Finalizado"
                                                            height={24}
                                                            width={24} />
                                                    ) : props.work.FechaFinalizacion ? (
                                                        <Image 
                                                            src={flagIcon}
                                                            alt="Finalizado"
                                                            height={24}
                                                            width={24} />
                                                    ) : (
                                                        <Image 
                                                            src={pauseIcon}
                                                            alt="Finalizado"
                                                            height={24}
                                                            width={24} />
                                                    )
                                                }
                                            </StackItem>
                                            <StackItem styles={{
                                                root: {
                                                    paddingLeft: 10,
                                                },
                                            }}>
                                                <Text variant="xSmall">
                                                    {moment(props.workPart.Inicio).format("DD-MM-YYYY HH:mm")}h - {moment(props.workPart.Fin).format("DD-MM-YYYY HH:mm")}h
                                                </Text>
                                            </StackItem>
                                        </Stack>
                                        <Text>
                                            {props.workPart.Descripcion}
                                        </Text>
                                    </>
                                </InfoWindow>
                            ) : (
                                null
                            )
                        }
                    </Marker>
                ) : (
                    null
                )
            }
            {
                directions ? (
                    <DirectionsRenderer 
                        directions={directions}
                        options={{
                            polylineOptions: {
                                strokeColor: "#ed6d63",
                                strokeOpacity: 1,
                                strokeWeight: 5,
                            },
                            markerOptions: {
                                visible: false,
                            },
                        }} />
                ) : (
                    null
                )
            }
        </>
    );
};

export default GoogleMapMarkerOrderComponent;
